import { createRouter, createWebHistory, type Router } from "vue-router";
import HomePage from "@/pages/home/HomePage.vue";
import RemoteErrorPage from "@/pages/remote-error/RemoteErrorPage.vue";
import { installAuthGuard } from "@/features/auth/guard";

function getRouterBasePath(baseUrl: string): string {
  try {
    const parsed = new URL(baseUrl);
    return parsed.pathname || "/";
  } catch {
    return baseUrl;
  }
}

export function createShellRouter(): Router {
  const router = createRouter({
    history: createWebHistory(getRouterBasePath(import.meta.env.BASE_URL)),
    routes: [
      {
        path: "/",
        name: "home",
        component: HomePage,
        meta: { requiresAuth: true },
      },
      {
        path: "/login",
        name: "login",
        component: () => import("@/pages/login/LoginPage.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/signin-callback",
        name: "signin-callback",
        component: () => import("@/pages/signin-callback/SigninCallbackPage.vue"),
        meta: { requiresAuth: false },
      },
      {
        // Terraform's health_check_path points at the static /health-check.txt
        // file (see terraform/*/app.tf), not this route. This route is kept
        // for humans checking app health in a browser.
        path: "/health-check",
        name: "health-check",
        component: () => import("@/pages/health-check/HealthCheckPage.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/404",
        name: "not-found",
        component: RemoteErrorPage,
        meta: { requiresAuth: false },
      },
    ],
  });

  // Same guard the ./auth expose ships to remote dev harnesses — one
  // implementation, so hosted and standalone navigation cannot diverge.
  installAuthGuard(router);

  return router;
}

let shellRouter: Router | null = null;

export function getShellRouter(): Router {
  if (!shellRouter) {
    shellRouter = createShellRouter();
  }

  return shellRouter;
}

export default getShellRouter();
